class HiddenText extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="hidden-text">
          Hidden Text
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-hidden-text" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">A11y Enabled hidden text</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<p className="hidden-text-demo">
  Well, the way they make shows is, they make one show. That show's called a pilot.
  Then they show that show to the people who make shows, and on the strength of
  that one show they decide if they're going to make more shows. Some pilots get
  picked and become television programs. Some dont, become nothing.
  She starred in one of the ones that became nothing.
</p>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.hidden-text-demo {
  @include hide-text();

  width: 300px;
  height: 250px;
  background-image: url(http://lorempixel.com/300/250/);
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <p className="hidden-text-demo">
                    Well, the way they make shows is, they make one show. That show's called a pilot.
                    Then they show that show to the people who make shows, and on the strength of
                    that one show they decide if they're going to make more shows. Some pilots get
                    picked and become television programs. Some dont, become nothing.
                    She starred in one of the ones that became nothing.
                  </p>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
